import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../Component/img/logo.png";
import login from "../Component/img/login.jfif";
import axios from "axios";
import { BASE_URL } from "../Component/Baseurl"; // Adjust the path as needed
import { GoogleOAuthProvider, GoogleLogin, useGoogleLogin } from "@react-oauth/google"; // Import GoogleLogin
import { ToastContainer, toast } from "react-toastify"; // Import toast notifications
import "react-toastify/dist/ReactToastify.css"; // Import styles for toast
import { Link } from "react-router-dom";
import NavbarVisitor from "../Component/NavbarVisitor";

const Login = () => {
  const [email, setEmail] = useState(""); // State for email input
  const [loading, setLoading] = useState(false); // State for loading state
  const navigate = useNavigate(); // For navigation after successful login

  // Encode email to Base64
  const encodeBase64 = (string) => {
    return btoa(string); // Encode string to Base64
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent page reload
    if (!email) {
      toast.error("Email is required"); // Display error if email is empty
      return;
    }

    setLoading(true); 

    try {
      const response = await axios.post(`${BASE_URL}login-visitor`, { email }); // API call

      // Log the entire response for debugging
      console.log("API Response:", response);

      // Check for status 200
      if (response.status === 200) {
        const encodedEmail = encodeBase64(email); // Encode email to Base64
        navigate(`/otp?email=${encodedEmail}`); // Redirect to OTP page
      } else {
        // Handle unexpected status
        toast.error("Unexpected response from server!");
      }
    } catch (error) {
      // Log the error response for debugging
      console.log("Error Response:", error.response);

      if (error.response?.status === 400) {
        toast.error(error.response?.data?.message || "Bad Request!");
      } else {
        toast.error("An error occurred!");
      }
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  // Handle Google Sign-In
  const handleGoogleSignIn = async (credentialResponse) => {
    const googleToken = credentialResponse.credential; // <-- this is the ID Token
  
    console.log("Google Token:", googleToken);  // This should now show a long JWT
  
    try {
      const response = await axios.post(`${BASE_URL}auth/google-login`, {
        tokenId: googleToken,
      });
  
      const { visitor_id, visitor_name, visitor_email, visitor_picture } = response.data.visitor;
  
      if (visitor_id && visitor_email) {
        localStorage.setItem("visitor_id", visitor_id);
        localStorage.setItem("visitor_name", visitor_name || "");
        localStorage.setItem("visitor_email", visitor_email);
        localStorage.setItem("visitor_picture", visitor_picture || "");
  
        // redirect logic
        const redirectUrl = localStorage.getItem("redirectUrl");
        if (redirectUrl && (redirectUrl.startsWith("http://") || redirectUrl.startsWith("https://"))) {
          window.location.href = redirectUrl;
        } else {
          navigate(visitor_name ? -1 : "/profile");
        }
      } else {
        toast.error("Login failed: Missing essential visitor data.");
      }
    } catch (error) {
      console.error("Google Sign-In Error:", error);
      toast.error("Google Sign-In failed. Please try again.");
    }
  };
  

  
  // const loginGoogle = useGoogleLogin({
  //   onSuccess: handleGoogleSignIn,
  //   onError: () => toast.error("Google Sign-In failed. Please try again."), 
  // });

  
  

  return (
    <GoogleOAuthProvider clientId="1042334379144-b0egq7it48fmd0spedaliusqsiermqud.apps.googleusercontent.com">
      <div className="">
        <NavbarVisitor/>
        <div className="row p-0 m-0 lam">
          <div className="col-md-6 p-0 m-0">
            <div className="row d-flex justify-content-center lam align-items-center p-0 m-0">
              <div className="col-md-7 col-11">
                <div>
                  
                  <div className="mb-2">
                    <h3 className="loinhd"><strong>Sign In</strong></h3>
                  </div>

                 

                    {/* Google Sign-In Button */}
                    <div className="mt-4">
                      <GoogleLogin 
                        onSuccess={handleGoogleSignIn}  className="google-login-btn"
                        onError={() => toast.error("Google Sign-In failed. Please try again.")}
                      />
                    </div>
{/* 
<div className="mt-2 mb-2">
  <button
    onClick={() => loginGoogle()}
    className="google-login-btn"
  >
    CONTINUE WITH GOOGLE
  </button>
</div> */}


    
<div className="or-line">
  <span className="orcls">OR</span>
</div>

                  <div>
                    <form onSubmit={handleSubmit}>
                      <div className="mb-2">
                        <input
                          type="email"
                          className="forminput"
                          id="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)} // Update email state
                          placeholder="Enter Your Email ..."
                          required
                        />
                      </div>


                      


                      <button
                        type="submit"
                        className="lginbtn mt-3"
                        disabled={loading} // Disable button during loading
                      >
                        {loading ? "Generating OTP..." : "Continue"}
                      </button>
                    </form>


<div className="terms-container text-start my-4">
  <label className=" text-secondary" style={{fontSize: "12px", fontWeight: '400'}}>
    {/* <input type="checkbox" className="terms-checkbox"  required /> */}

    By logging in, you are agreeing to our <a href="/privacy-policy" target="_blank">Privacy Policy</a> & <a href="/terms-conditions" target="_blank">Terms & Conditions</a> and acknowledge to receive communication from Evventoz

 
  </label>
</div>


                    

                    <hr/>

                    <div className="event-box">
  <a href="https://app.evventoz.com/" className="event-link" target="_blank" rel="noopener noreferrer">
    <div className="event-content">
      <div className="text-start">
        <h4>I'm an event organizer</h4>
        <p>Sign in to set up events, sell tickets, and deliver experiences.</p>
      </div>
      <span className="open-icon">↗</span>
    </div>
  </a>
</div>


                   
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 p-0 m-0 hide-on-mobile">
            <img src={login} alt="" className="img-fluid lgoin" />
          </div>
        </div>
      </div>
      <ToastContainer /> {/* Toast container for displaying toasts */}
    </GoogleOAuthProvider>
  );
};

export default Login;
